import { SVGProps } from 'react';

const Flower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 12a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m0 7.5a4.5 4.5 0 1 0 4.5-4.5H15m-3 3a3 3 0 0 1-3-3m0 0H7.5a4.5 4.5 0 1 0 4.5 4.5V15m-3-3a3 3 0 0 1 3-3m4.5 3A4.5 4.5 0 1 0 12 7.5V9m-4.5 3A4.5 4.5 0 1 1 12 7.5M8 8l1.88 1.88m4.24 0L16 8m-8 8 1.88-1.88m4.24 0L16 16"
    />
  </svg>
);
export default Flower;
